<template>
  <div class="card-body py-3">
    <h3 class="mb-0 t-500">
      Disciplines
      <i class="fa fa-star d-block pull-right t-placeholder"></i>
    </h3>

    <template v-if="isLoaded">
      <!--  no discipline present and cannot edit -->
      <p v-if="researchGroup.disciplines.length <= 0" class="mb-0 mt-1 t-sm t-secondary">
        No disciplines shared.
      </p>

      <!-- render disciplines -->
      <div v-else class="mt-3">
        <ul class="list-unstyled mb-0 clearfix flex-wrap d-flex">
          <li v-for="(d, index) in researchGroup.disciplines" :key="index" class="badge badge-pill badge-secondary--white mr-2 mb-2 bd-radius word-overflow position-relative" v-tooltip.top="`${d.name} (${d.count})`">
            {{ d.name }} <span class="t-smt-secondary">({{ d.count }})</span>
          </li>
        </ul>
      </div>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'researchGroupType',
  components: {
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    }
  }
}
</script>
